/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vbWFya2V0aW5nL21hcmtldGluZy1kYXNoYm9hcmQvc2hhcmVkLWxpc3Rpbmcvc2hhcmVkLWxpc3RpbmcuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
